import { render, staticRenderFns } from "./PurchaseInvoiceEditView.vue?vue&type=template&id=08aa6fbb"
import script from "./PurchaseInvoiceEditView.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports